export default __webpack_public_path__ + "static/media/close-tab.87767bbc.svg";